import { defineComponent as c, useCssModule as u, computed as t, openBlock as m, createBlock as p, resolveDynamicComponent as C, normalizeClass as g, unref as o, withCtx as h, renderSlot as k } from "vue";
import v from "../../utils/mapClasses.mjs";
import y from "../../utils/propValidator.mjs";
const a = "cdr-link", b = /* @__PURE__ */ c({
  name: "CdrLink",
  __name: "CdrLink",
  props: {
    /**
     * Sets valid HTML element tag
     * @values a, button
     */
    tag: {
      type: String,
      default: "a"
    },
    /**
     * Sets value for anchors href property. Requires tag prop value to be `a`.
     */
    href: {
      type: String,
      default: "#"
    },
    /**
     * Sets color and fill
     */
    inheritColor: {
      type: Boolean,
      default: !1
    },
    /**
     * Modifies the style variant for this component.
     * @values standalone
     */
    modifier: {
      type: String,
      default: "",
      validator: (r) => y(r, ["", "standalone"])
    },
    /** @ignore */
    target: String,
    /** @ignore */
    rel: String
  },
  setup(r) {
    const e = r, l = u(), n = t(() => e.tag === "a" ? e.href : null), i = t(() => e.target === "_blank" ? e.rel || "noopener noreferrer" : e.rel), s = t(() => e.modifier ? `${a}--${e.modifier}` : ""), f = t(() => e.inheritColor ? "cdr-link--inherit-color" : "");
    return (d, S) => (m(), p(C(r.tag), {
      class: g(o(v)(o(l), a, s.value, f.value)),
      target: r.target,
      rel: i.value,
      href: n.value
    }, {
      default: h(() => [k(d.$slots, "default")]),
      _: 3
    }, 8, ["class", "target", "rel", "href"]));
  }
});
export {
  b as default
};
